document.querySelectorAll(".accordion-collection [aria-selected]").forEach(button => {
  button.addEventListener("click", () => {
    button.ariaSelected = button.ariaSelected === "true" ? "false" : "true";
  });
});
